import { render, staticRenderFns } from "./retailsupplementinfo.vue?vue&type=template&id=39e66337&scoped=true"
import script from "./retailsupplementinfo.vue?vue&type=script&lang=js"
export * from "./retailsupplementinfo.vue?vue&type=script&lang=js"
import style0 from "./retailsupplementinfo.vue?vue&type=style&index=0&id=39e66337&prod&lang=scss&scoped=true"
import style1 from "./retailsupplementinfo.vue?vue&type=style&index=1&id=39e66337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e66337",
  null
  
)

export default component.exports